import { render, staticRenderFns } from "./Order-history.vue?vue&type=template&id=5f8ace78&"
import script from "./Order-history.vue?vue&type=script&lang=js&"
export * from "./Order-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports